import { SearcherStatus } from '@/components/common/searcher/shared/models/common-searcher.model'

export interface BaseSearcherState {
    loaded: boolean
    status: SearcherStatus
}
export const initialBaseSearcherState =
    (): BaseSearcherState => ({
        loaded: false,
        status: SearcherStatus.NO_SEARCH_DONE_YET
    })
